const supportedLanguages = [
  {
    key: "en",
    value: "ENG",
  },
  {
    key: "tr",
    value: "TUR",
  },
  {
    key: "es",
    value: "ESP",
  },
  {
    key: "pt",
    value: "PRT",
  },
  {
    key: "it",
    value: "ITA",
  },
];

export default supportedLanguages;
